"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 沪深港通十大成交股
 */
var base_1 = __importDefault(require("./base"));
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var moment_1 = __importDefault(require("moment"));
var wconfig = require('../../config/web.js');
function loadZjlxData() {
    base_1["default"].load_zjlx_table();
}
loadZjlxData();
setInterval(loadZjlxData, 60000);
var init_table = $("#dataview_hgt").html();
var top10_cjb = {
    init: function () {
        this.rollingnews();
        this.load_top10_table("dataview_hgt", "001");
        this.load_top10_table("dataview_sgt", "003");
        this.load_top10_table("dataview_ggth", "002");
        this.load_top10_table("dataview_ggts", "004");
    },
    rollingnews: function () {
        $.ajax({
            url: wconfig.getWebPath('newsinfo') + 'kuaixun/v2/api/Channel/5/0/0/20',
            type: 'GET',
            dataType: 'jsonp'
        }).then(function (json) {
            if (json.data) {
                var rollingData = json.data;
                var arr = [];
                arr.push('<ul class="scrollList" style="position:relative;right:0;">');
                for (var i = 0; i < rollingData.length; i++) {
                    var data = rollingData[i];
                    var art_url = "//finance.eastmoney.com/a/" + data.Art_Code + ".html";
                    arr.push('<li><a href="' + art_url + '">' + data.Art_Title + '</a><span class="time">' + fieldtools_1["default"].dateformat(data.Art_ShowTime, "HH:mm") + '</span></li>');
                }
                for (var i = 0; i < rollingData.length; i++) {
                    var data = rollingData[i];
                    var art_url = "//finance.eastmoney.com/a/" + data.Art_Code + ".html";
                    arr.push('<li><a href="' + art_url + '">' + data.Art_Title + '</a><span class="time">' + fieldtools_1["default"].dateformat(data.Art_ShowTime, "HH:mm") + '</span></li>');
                }
                arr.push('</ul>');
                $(".scrollDiv").html(arr.join(""));
                var scrollCon = $(".scrollWrap .scrollCon");
                var scrollUl = $(".scrollWrap .scrollList").eq(0);
                var bjw = scrollUl.width() / 2;
                var timer;
                timer = setInterval(function () {
                    var right = parseInt(scrollUl.css("right").replace('px', ''));
                    right = right + 1;
                    if (right > bjw)
                        right = 0;
                    scrollUl.css("right", right + 1);
                }, 40);
                scrollCon.hover(function () {
                    clearInterval(timer);
                }, function () {
                    timer = setInterval(function () {
                        var right = parseInt(scrollUl.css("right").replace('px', ''));
                        right = right + 1;
                        if (right > bjw)
                            right = 0;
                        scrollUl.css("right", right + 1);
                    }, 40);
                });
            }
        });
    },
    load_top10_table: function (id, mkt) {
        if ($("#" + id).children("table").length < 1) {
            $("#" + id).append(init_table);
        }
        var opt = {
            dataurl: {
                hostname: 'datacenter',
                url: 'api/data/v1/get',
                params: {
                    reportName: 'RPT_MUTUAL_TOP10DEAL',
                    columns: 'ALL',
                    pageSize: 10,
                    source: "WEB",
                    client: "WEB",
                    filter: "(MUTUAL_TYPE=\"" + mkt + "\")(TRADE_DATE='" + date + "')"
                }
            },
            pagination: false,
            sortname: "RANK",
            sortorder: "asc",
            urlkeyvalues: base_1["default"].urlkeyvalues,
            columns: base_1["default"]["top10"].columns,
            formatter: { strfmt: true },
            onPreBody: function (data, that) {
                //显示日期
                var arr_week = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
                var show_date = date;
                if (!fieldtools_1["default"].isEmpty(data) && data.length > 0) {
                    show_date = data[0].TRADE_DATE;
                }
                var weekday = moment_1["default"](show_date).day();
                var date_txt = "(" + fieldtools_1["default"].dateformat(show_date) + arr_week[weekday] + ")";
                $(".title .date").text(date_txt);
                //更新表头
                var mapping = {
                    "001": ["沪股通", ""],
                    "003": ["深股通", ""],
                    "002": ["港股通(沪)", "(港元)"],
                    "004": ["港股通(深)", "(港元)"]
                };
                var text = mapping[mkt];
                that.updateColumnTitle([
                    { field: "NET_BUY_AMT", title: text[0] + "<br/>\u51C0\u4E70\u989D" + text[1] },
                    { field: "BUY_AMT", title: text[0] + "<br/>\u4E70\u5165\u91D1\u989D" + text[1] },
                    { field: "SELL_AMT", title: text[0] + "<br/>\u5356\u51FA\u91D1\u989D" + text[1] },
                    { field: "DEAL_AMT", title: text[0] + "<br/>\u6210\u4EA4\u91D1\u989D" + text[1] }
                ]);
                return true;
            }
        };
        $("#" + id).emdataview(opt);
    }
};
function showTime() {
    var html = "<div class=\"selectRegion\"  onClick=\"WdatePicker({ el:'inputDate', dchanged: " + changeTime + ", position:{left:-85} })\">\n                  <input type=\"text\" id=\"inputDate\" class=\"dll\" value=\"\" readonly=\"readonly\">\n                  <b class=\"icon icon_dateSelector\"></b>\n                </div>";
    $('.calendarBox').append(html);
    $('#inputDate').val(date);
}
function changeTime() {
    var date = $dp.cal.newdate;
    var month = date.M >= 10 ? date.M : '0' + date.M;
    var day = date.d >= 10 ? date.d : '0' + date.d;
    var newdate = date.y + '-' + month + '-' + day;
    window.location.href = '/hsgt/top10/' + newdate + '.html';
}
showTime();
top10_cjb.init();
